<template>
    <div
        class="templates_limits__container flex align-items-center text-sm gap-2 white-space-nowrap"
        v-bind="getPT('root')"
    >
        <span class="text-color-secondary">{{ $t('lang.templates.limits.label') }}</span>
        <span>{{ $t('lang.templates.limits.count', getCountLimits) }}{{ suffix ? ` ${suffix}` : '' }}</span>
        <slot name="additional"></slot>
    </div>
</template>

<script>
import PassThrough from "keysso/mixins/PassThrough";

export default {
    name: "TemplatesLimits",
    mixins: [PassThrough],
    props: {
        limits: {
            type: Number,
            required: false,
            default: 0,
        },
        // необязательное уточнение после числа лимитов (например, «за одну проверку»)
        suffix: {
            type: String,
            required: false,
            default: '',
        },
    },
    computed: {
        getCountLimits() {
            return this.limits || 0;
        },
    },
}
</script>

<style scoped>
.templates_limits__container {
    background-color: #6EB1161A;
    padding: 14px 30px;
    border-radius: var(--border-radius);
}
</style>
